/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Questionnaire type (commercial reality asset, energy asset, client)

Values: commercial_reality_asset=CommercialRealityAsset, energy_asset=EnergyAsset, client=Client
 * @export
 * @enum {string}
 */

export enum QuestionnaireType {
    CommercialRealityAsset = 'commercial_reality_asset',
    EnergyAsset = 'energy_asset',
    Client = 'client'
}


